<template>
	<v-layout column>
		<v-subheader v-if="(model && model.length > 0) || !inputDisabled">
			{{ label }}
		</v-subheader>

		<v-flex xs3>
			<v-btn v-if="!inputDisabled" @click="addSub()">
				{{ 'Ajouter ' + label }}
			</v-btn>
		</v-flex>

		<!-- handling error and validator -->
		<v-text-field v-model="model" class="custom-error" :rules="computedRules"></v-text-field>

		<v-layout row v-for="(line, lineIndex) in model" :key="'line' + lineIndex" style="align-items: center;">
			<v-layout row wrap style="align-items: center;">
				<v-flex
					v-for="(item, index) in items"
					:key="item.value + lineIndex + 'line' + index"
					v-if="!item.hide || !item.hide(line[item.value])"
					@click="item.click && item.click(line[item.value])"
					v-bind="item.grid"
				>
					<b-o-input :input="item" v-model="line[item.value]" @change="update"> </b-o-input>
				</v-flex>
			</v-layout>
			<v-btn v-if="!inputDisabled" icon @click="deleteSub(lineIndex)">
				<v-icon>close</v-icon>
			</v-btn>
		</v-layout>
	</v-layout>
</template>

<script>
import BaseInput from './baseInput'
import BOInput from '../boInput'

export default {
	extends: BaseInput,
	components: { BOInput },
	props: ['items'],
	computed: {
		computedRules() {
			let res = []
			if (this.rules) {
				res = [...this.rules]
			}
			if (this.inputRequired) {
				res.push((v) => (!!v && v.length > 0) || this.label + ' requis')
			}
			return res
		},
	},
	methods: {
		init() {
			if (this.value !== undefined && this.value !== null) {
				this.model = this.value
			}
		},
		deleteSub(index) {
			this.model.splice(index, 1)
			this.update()
		},
		addSub() {
			if (!this.model) {
				this.model = []
			}
			this.model.push({})
			this.update()
		},
		updateDisabled() {
			let itemDisabled
			for (let i = 0; i < this.items.length; i++) {
				itemDisabled = this.items[i].privateDisabled
				if (typeof itemDisabled === 'function') {
					itemDisabled = itemDisabled()
				}
				this.$set(this.items[i], 'disabled', this.inputDisabled || itemDisabled)
			}
		},
	},
	watch: {
		inputDisabled() {
			this.updateDisabled()
		},
	},
	mounted() {
		this.init()
		this.updateDisabled()
	},
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/subArrayInput.vue